import { ApolloError } from "@apollo/client";
import { Save as IconSave } from "@mui/icons-material";
import { Button, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import GaiaDeleteButton from "~/modules/app/components/GaiaDeleteButton";
import { extractFormData } from "~/modules/settings/shared/formTemplateEditor/util/extractFormData";
import { Shared_FormTemplate_QuestionFragment } from "~/shared/components/FormTemplate/fragments/fragments.generated";

import FormTemplateQuestionForm, { FormTemplateQuestionFormInputs } from "../FormTemplateQuestionForm";

type Props = {
    currentQuestion: Shared_FormTemplate_QuestionFragment;
    siblingSelectableQuestions: Shared_FormTemplate_QuestionFragment[];
    onSubmit: (value: FormTemplateQuestionFormInputs) => void;
    onDelete: () => Promise<void>;
    onCancel: () => void;
    error?: ApolloError;
    isUpdateQuestionLoading: boolean;
    isDeleteQuestionLoading: boolean;
};

export default function ExpandedQuestionItem({
    currentQuestion,
    siblingSelectableQuestions,
    onSubmit,
    onDelete,
    onCancel,
    isUpdateQuestionLoading,
    isDeleteQuestionLoading,
    error,
}: Props) {
    const { t } = useTranslation("formTemplateEditor");

    const initialData: FormTemplateQuestionFormInputs = extractFormData(currentQuestion);

    return (
        <FormTemplateQuestionForm
            initialData={initialData}
            selectableConditionQuestions={siblingSelectableQuestions}
            onSubmit={onSubmit}
            error={error}
            actions={isDirtyState => (
                <Stack direction="row" justifyContent="space-between">
                    <GaiaDeleteButton
                        label={t("formTemplateQuestionForm.btnDelete")}
                        onDelete={onDelete}
                        isLoading={isDeleteQuestionLoading}
                    />
                    <Stack direction="row" justifyContent="space-between" columnGap={2}>
                        <Button onClick={onCancel} color="primary">
                            {t("formTemplateQuestionForm.btnCancel")}
                        </Button>
                        <Button
                            type="submit"
                            color="primary"
                            variant="contained"
                            disabled={isDirtyState || isUpdateQuestionLoading}
                        >
                            <IconSave />
                            {t("formTemplateQuestionForm.btnSave")}
                        </Button>
                    </Stack>
                </Stack>
            )}
        />
    );
}
